import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SidebarService {
  // BehaviorSubject mantém o último estado para quem se inscrever depois
  private _isCollapsed = new BehaviorSubject<boolean>(false);

  // Observable público para componentes reagirem
  isCollapsed$ = this._isCollapsed.asObservable();

  constructor() {}

  toggle() {
    this._isCollapsed.next(!this._isCollapsed.value);
  }

  setCollapsed(state: boolean) {
    this._isCollapsed.next(state);
  }

  get isCollapsed(): boolean {
    return this._isCollapsed.value;
  }
}
